import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

export function Footer(): JSX.Element {
	return (
		<Box sx={{ textAlign: 'center', font: 'body' }}>
			<Text size="caption" data-qa="ppmu-modal-footer-text">
				<Translate value="corgi.co.ppmu.modal.footer_text" />
			</Text>
		</Box>
	);
}
